var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 6,
    viewBox: "0 0 36 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.5H0V3.5H0.5V2.5ZM35.5 3L30.5 0.113249V5.88675L35.5 3ZM0.5 3.5H31V2.5H0.5V3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowRight);
export default __webpack_public_path__ + "static/media/longArrowRight.ac64193697b831e659262d441591af58.svg";
export { ForwardRef as ReactComponent };